export default __webpack_public_path__ + "static/media/dynatrace.46a07417.svg";